function flowers(image) {
    const width = 1672, height = 941;
    const source = document.createElement('canvas');
    source.width = width;
    source.height = height;
    const ctx = source.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(image, 0, 0, width, height);
    const pixels = ctx.getImageData(0, 0, width, height).data;
    const mask = new Uint8Array(width * height), seen = new Uint8Array(width * height);
    for (let y = 590; y < height; y++)
        for (let x = 0; x < width; x++) {
            const i = y * width + x, j = i * 4, r = pixels[j], g = pixels[j + 1], b = pixels[j + 2];
            if (r > 150 && g > 95 && r > g * 1.12 && g > b * 1.6 && r > b * 2)
                mask[i] = 1;
        }
    const output = [];
    for (let index = 590 * width; index < mask.length; index++) {
        if (!mask[index] || seen[index])
            continue;
        const queue = [index];
        seen[index] = 1;
        let lowX = width, lowY = height, highX = 0, highY = 0;
        for (let q = 0; q < queue.length; q++) {
            const n = queue[q], x = n % width, y = Math.floor(n / width);
            lowX = Math.min(x, lowX);
            highX = Math.max(x, highX);
            lowY = Math.min(y, lowY);
            highY = Math.max(y, highY);
            for (let dy = -2; dy <= 2; dy++)
                for (let dx = -2; dx <= 2; dx++) {
                    const xx = x + dx, yy = y + dy, m = yy * width + xx;
                    if (xx >= 0 && xx < width && yy >= 590 && yy < height && mask[m] && !seen[m]) {
                        seen[m] = 1;
                        queue.push(m);
                    }
                }
        }
        if (queue.length < 10)
            continue;
        const x = Math.max(0, lowX - 2), y = Math.max(0, lowY - 2), w = Math.min(width - x, highX - lowX + 5), h = Math.min(height - y, highY - lowY + 5);
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const c = canvas.getContext('2d'), data = c.createImageData(w, h);
        for (let yy = 0; yy < h; yy++)
            for (let xx = 0; xx < w; xx++) {
                const global = (y + yy) * width + x + xx, j = global * 4, k = (yy * w + xx) * 4;
                let alpha = mask[global] ? 255 : 0;
                if (!alpha && pixels[j] > 100 && pixels[j + 1] > 75 && pixels[j + 2] < 90) {
                    for (let d = -1; d <= 1; d++)
                        if (mask[global + d] || mask[global + d * width])
                            alpha = 150;
                }
                data.data[k] = pixels[j];
                data.data[k + 1] = pixels[j + 1];
                data.data[k + 2] = pixels[j + 2];
                data.data[k + 3] = alpha;
            }
        c.putImageData(data, 0, 0);
        output.push({ canvas, x, y, w, h, phase: x * .017 + y * .008 });
    }
    return output;
}
function originalLetters(image) {
    const c = document.createElement('canvas');
    c.width = 1672;
    c.height = 941;
    const ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(image, 0, 0);
    const output = [];
    for (const [left, top, width, height] of [[640, 315, 350, 100], [660, 415, 390, 81], [680, 496, 270, 82]]) {
        const pixels = ctx.getImageData(left, top, width, height), columns = new Uint8Array(width);
        for (let y = 0; y < height; y++)
            for (let x = 0; x < width; x++) {
                const i = (y * width + x) * 4, d = pixels.data;
                const light = Math.min(d[i], d[i + 1], d[i + 2]);
                const alpha = Math.max(0, Math.min(1, (light - 180) / 65));
                d[i] = 255;
                d[i + 1] = 255;
                d[i + 2] = 250;
                d[i + 3] = Math.round(alpha * 255);
                if (alpha > .15)
                    columns[x] = 1;
            }
        let start = -1;
        for (let x = 0; x <= width; x++) {
            if (x < width && columns[x] && start < 0)
                start = x;
            if (start >= 0 && (x === width || !columns[x])) {
                const w = x - start, canvas = document.createElement('canvas');
                canvas.width = w;
                canvas.height = height;
                const line = document.createElement('canvas');
                line.width = width;
                line.height = height;
                line.getContext('2d').putImageData(pixels, 0, 0);
                canvas.getContext('2d').drawImage(line, start, 0, w, height, 0, 0, w, height);
                output.push({ canvas, x: left + start, y: top, w, h: height, phase: output.length * 2.1 });
                start = -1;
            }
        }
    }
    return output;
}
class TitiLandscape extends HTMLElement {
    connectedCallback() {
        if (this.dataset.custom === 'true' || this.cleanup)
            return;
        const element = this, canvas = this.querySelector('canvas'), originalType = this.dataset.letters === 'true', button = this.querySelector('button');
        const playRef = { current: this.dataset.motion === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches };
        button.hidden = false;
        const label = () => { button.textContent = playRef.current ? this.dataset.pause : this.dataset.play; button.setAttribute('aria-pressed', String(playRef.current)); };
        label();
        button.onclick = () => { playRef.current = !playRef.current; label(); };
        let stopped = false, frame = 0, visible = true;
        const original = new Image(), plate = new Image();
        original.crossOrigin = 'anonymous';
        plate.crossOrigin = 'anonymous';
        original.src = this.dataset.original;
        plate.src = this.dataset.plate;
        const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
        observer.observe(element);
        Promise.all([original.decode(), plate.decode()]).then(() => {
            if (stopped)
                return;
            const blooms = flowers(original), letters = originalLetters(original), ctx = canvas.getContext('2d');
            const sky = document.createElement('canvas');
            sky.width = 1672;
            sky.height = 310;
            const skyCtx = sky.getContext('2d');
            skyCtx.drawImage(original, 0, 0, 1672, 310, 0, 0, 1672, 310);
            const skyPixels = skyCtx.getImageData(0, 0, 1672, 310);
            for (let i = 0; i < skyPixels.data.length; i += 4) {
                const d = skyPixels.data;
                d[i + 3] = Math.round(255 * Math.max(0, Math.min(1, (Math.min(d[i], d[i + 1], d[i + 2]) - 135) / 45)));
            }
            skyCtx.putImageData(skyPixels, 0, 0);
            skyCtx.globalCompositeOperation = 'destination-in';
            const fade = skyCtx.createLinearGradient(0, 145, 0, 300);
            fade.addColorStop(0, 'rgba(0,0,0,.95)');
            fade.addColorStop(1, 'rgba(0,0,0,0)');
            skyCtx.fillStyle = fade;
            skyCtx.fillRect(0, 0, 1672, 310);
            let previous = performance.now(), time = 0, intro = 0;
            const draw = (now) => {
                if (stopped)
                    return;
                frame = requestAnimationFrame(draw);
                if (now - previous < 33)
                    return;
                const delta = (now - previous) / 1000;
                previous = now;
                if (!visible || document.hidden)
                    return;
                if (playRef.current) {
                    time += delta * Number(this.dataset.speed || 1);
                    intro += delta;
                }
                else
                    intro = 5;
                const width = element.clientWidth, height = element.clientHeight, dpr = Math.min(devicePixelRatio || 1, 1.5);
                if (canvas.width !== Math.round(width * dpr) || canvas.height !== Math.round(height * dpr)) {
                    canvas.width = Math.round(width * dpr);
                    canvas.height = Math.round(height * dpr);
                }
                const scale = Math.max(width / 1672, height / 941), left = (width - 1672 * scale) / 2, top = (height - 941 * scale) / 2;
                ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
                ctx.clearRect(0, 0, width, height);
                ctx.translate(left, top);
                ctx.scale(scale, scale);
                ctx.drawImage(plate, 0, 0, 1672, 941);
                ctx.save();
                const drift = 60 * Math.sin(time / 10);
                ctx.drawImage(sky, -90 + drift, -1, 1852, 310);
                ctx.restore();
                for (const bloom of blooms) {
                    const depth = (bloom.y - 570) / 370, stem = 20 + depth * 100;
                    const bx = bloom.x + bloom.w / 2, by = bloom.y + bloom.h + stem;
                    const angle = (Math.sin(time * .9 + bloom.phase * .3) * .095 + Math.sin(time * 1.4 + bloom.phase) * .025) * depth;
                    ctx.save();
                    ctx.translate(bx, by);
                    ctx.rotate(angle);
                    ctx.strokeStyle = '#596b3280';
                    ctx.lineWidth = .7 + depth * .7;
                    ctx.lineCap = 'round';
                    ctx.beginPath();
                    ctx.moveTo(0, 0);
                    ctx.bezierCurveTo(-1, -stem * .5, 1, -stem, -1, -stem - 2);
                    ctx.stroke();
                    ctx.drawImage(bloom.canvas, -bloom.w / 2, -stem - bloom.h);
                    ctx.restore();
                }
                if (originalType)
                    for (const glyph of letters) {
                        const remaining = Math.max(0, 1 - intro / 5), ease = remaining * remaining;
                        ctx.save();
                        ctx.translate(glyph.x + glyph.w / 2 + Math.sin(glyph.phase) * 85 * ease, glyph.y + glyph.h / 2 + Math.cos(glyph.phase) * 65 * ease);
                        ctx.rotate(Math.sin(glyph.phase + intro * 2) * .35 * ease);
                        ctx.globalAlpha = Math.min(1, .4 + intro);
                        ctx.drawImage(glyph.canvas, -glyph.w / 2, -glyph.h / 2);
                        ctx.restore();
                    }
            };
            this.classList.add('ready');
            frame = requestAnimationFrame(draw);
        }).catch(() => { });
        this.cleanup = () => { stopped = true; cancelAnimationFrame(frame); observer.disconnect(); };
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
}
class TitiMenu extends HTMLElement {
    connectedCallback() { const input = this.querySelector('input'), buttons = [...this.querySelectorAll('[data-cat]')].filter(x => x.tagName === 'BUTTON'), items = [...this.querySelectorAll('.tt-product')]; let cat = 'all'; const normalize = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/đ/g, 'd').toLowerCase(); const filter = () => { let count = 0; for (const item of items) {
        item.hidden = !(cat === 'all' || item.dataset.cat === cat) || !normalize(item.dataset.name).includes(normalize(input.value));
        if (!item.hidden)
            count++;
    } this.querySelector('.tt-no-results').hidden = count > 0; }; input.oninput = filter; for (const b of buttons)
        b.onclick = () => { cat = b.dataset.cat; buttons.forEach(x => x.setAttribute('aria-pressed', String(x === b))); filter(); }; }
}
if (!customElements.get('titi-landscape'))
    customElements.define('titi-landscape', TitiLandscape);
if (!customElements.get('titi-menu'))
    customElements.define('titi-menu', TitiMenu);
